import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Centros } from './Centros';
import { Dre } from './Dre';
import { Exportacoes } from './Exportacoes';
import { Extrato } from './Extrato';
import { Fluxo } from './Fluxo';
import { i18n } from './i18n';
import { Inadimplencia } from './Inadimplencia';
import { Margem } from './Margem';
import { Mrr } from './Mrr';
import { Parceiros } from './Parceiros';
import { PaginaRelatorios } from './PaginaRelatorios';
import { Folha } from './Folha';
import { Quadro } from './Quadro';
import { PainelGrupo } from './PainelGrupo';

/**
 * Fase 2, W13: módulo Relatórios no menu Financeiro (decisão B5 e D16), depois do Financeiro e do Contas. W31 (6.2 e decisão 5
 * de 05/10): item próprio do menu lateral, com a página de entrada (um cartão por relatório) como primeira aba; o caminho
 * antigo `/financeiro/relatorios/...` leva ao novo (`destinoDaAbaProjetada`).
 */
const modulo: ModuloWeb = {
  slug: 'relatorios',
  menu: 'relatorios',
  ordem: 10,
  abas: [
    { chave: 'inicio', permissao: ['relatorios.ver', 'relatorios.exportar'], componente: PaginaRelatorios },
    // Lote 19 (item 3): painel do grupo, só para quem vê todas as empresas com o consolidado (o servidor confere o mesmo).
    { chave: 'painel-grupo', permissao: 'relatorios.ver', todasAsEmpresas: true, componente: PainelGrupo },
    { chave: 'inadimplencia', permissao: 'relatorios.ver', componente: Inadimplencia },
    { chave: 'dre', permissao: 'relatorios.ver', componente: Dre },
    { chave: 'fluxo', permissao: 'relatorios.ver', componente: Fluxo },
    { chave: 'extrato', permissao: 'relatorios.ver', componente: Extrato },
    { chave: 'centros', permissao: 'relatorios.ver', componente: Centros },
    { chave: 'parceiros', permissao: 'relatorios.ver', componente: Parceiros },
    { chave: 'mrr', permissao: 'relatorios.ver', componente: Mrr },
    // Fase 2 (W21, K13): R8 margem por serviço.
    { chave: 'margem', permissao: 'relatorios.ver', componente: Margem },
    // E1 (resposta 6 do Gustavo): Pessoas e Folha nos relatórios. A aba pede a leitura do módulo dono (a folha é sensível);
    // o servidor confere também `relatorios.ver`.
    { chave: 'quadro', permissao: 'pessoas.ver', componente: Quadro },
    { chave: 'folha', permissao: 'folha.ver', componente: Folha },
    { chave: 'exportacoes', permissao: 'relatorios.exportar', componente: Exportacoes },
  ],
  i18n,
};

export default modulo;
